export default __webpack_public_path__ + "static/media/11.bc18fd13.jpg";